import {
  CommonHelperFunctions,
  ESdChangeReason,
  ESymbolCategory,
  IAction,
  IActionParameter,
  IComponent,
  IDesign,
  IDisplayItem,
  IDisplayItemComponent,
  IDisplayItemProperty,
  IProject,
  IPropertyDefinition,
  IScreenDesign,
  SpecialDIIds
} from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { PropertySdHelper } from "../../../../shared/utility/property-sd-helper";
import KuikaSelectbox, {
  KuikaSelectboxOption,
  KuikaSelectboxOptionGroup
} from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";

export interface ISelectElementIdSymbolGroupState {}

export interface ISelectElementIdSymbolGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild) => void;
}

class SelectElementIdSymbolGroup extends PureSdComponent<
  ISelectElementIdSymbolGroupProps & IWithSDProps & IWithContextProp,
  ISelectElementIdSymbolGroupState
> {
  propertySdHelper: PropertySdHelper;

  constructor(props: ISelectElementIdSymbolGroupProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.propertySdHelper = new PropertySdHelper(this.getScreenDesignContextProviderValues);
  }

  getScreenDesignContextProviderValues = () => {
    return this.props.sd;
  };

  handleComponentSelect = (value: any, allDi: IDisplayItem[], allMasterDi: IDisplayItem[]) => {
    let fixedValue = allDi[value]?.id;
    // if (typeof value === "string" && value?.includes("_master")) {
    //   fixedValue = parseInt(allMasterDi[value.replace("_master", "")]?.id);
    // }
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = this.props.parameters.find((element) => element.name === "element")!;
    if (_parameter === undefined) {
      return;
    }
    if (!_parameter.symbol) _parameter.symbol = {} as any;
    _parameter.symbol.fixedValue = fixedValue;
    _parameter.symbol.category = ESymbolCategory.fixed;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate);
  };

  getSelectValue = (allDi: IDisplayItem[], allMasterDi: IDisplayItem[]) => {
    let selectValue;
    const _parameter = this.props.parameters.find((element) => element.name === "element")!;
    if (_parameter && _parameter.symbol) {
      const { fixedValue } = _parameter.symbol;
      allDi.forEach((di, i) => {
        if (di.id.toString() === fixedValue.toString()) {
          selectValue = i;
        }
      });
      // allMasterDi.forEach((di, i) => {
      //   if (di.id.toString() === fixedValue.toString()) {
      //     selectValue = `${i}_master`;
      //   }
      // });
    }
    return selectValue;
  };

  getPropertyDefinition = (
    diComponent: IDisplayItemComponent,
    diProperty: IDisplayItemProperty,
    project: IProject
  ): IPropertyDefinition | undefined => {
    if (project.componentSetObj && project.componentSetObj.components) {
      const component: IComponent | undefined = CommonHelperFunctions.findComponentById(
        diComponent?.id,
        project.componentSetObj.components
      );
      if (component) {
        const property = component.properties.find((p) => p.name === diProperty.name);
        if (property) {
          const result: IPropertyDefinition = {
            description: property.description,
            hasOptions: property.hasOptions,
            isRequired: property.isRequired,
            isTechnical: property.isTechnical,
            // isEvent: property.isEvent,
            isVisibleInFieldPicker: property.isVisibleInFieldPicker,
            isValueProp: property.isValueProp,
            isOptionsProp: property.isOptionsProp,
            isLanguageOptionsProp: property.isLanguageOptionsProp,
            isEditabilityProp: property.isEditabilityProp,
            isVisibleProp: property.isVisibleProp,
            isAdvanced: property.isAdvanced,
            isIgnoredOnCodeOutput: property.isIgnoredOnCodeOutput,
            isIgnoredOnGeneratedApp: property.isIgnoredOnGeneratedApp,
            isSupportMultiLanguage: property.isSupportMultiLanguage,
            appSupportType: property.appSupportType,
            isDeprecated: property.isDeprecated,
            name: property.name,
            options: property.options,
            tagName: property.tagName,
            type: property.type,
            typeOptions: property.typeOptions,
            defaultValue: property.symbol?.category === ESymbolCategory.fixed ? property.symbol.fixedValue : "",
            isChartOptionsProp: property.isChartOptionsProp,
            isTimelineOptionsProp: property.isTimelineOptionsProp,
            isChatOptionsProp: property.isChatOptionsProp,
            isCalendarOptionsProp: property.isCalendarOptionsProp,
            isNodeTreeNodeOptionsProp: property.isNodeTreeNodeOptionsProp,
            isMenuOptionsProp: property.isMenuOptionsProp,
            isBreadcrumbOptionsProp: property.isBreadcrumbOptionsProp,
            isRadialChartOptionsProp: property.isRadialChartOptionsProp,
            isRadialChartLevelOptionsProp: property.isRadialChartLevelOptionsProp,
            isMixedChartLineOptionsProp: property.isMixedChartLineOptionsProp,
            isMixedChartPointOptionsProp: property.isMixedChartPointOptionsProp,
            isMixedChartBarOptionsProp: property.isMixedChartBarOptionsProp,
            isTreeOptionsProp: property.isTreeOptionsProp,
            inVisibleStyles: property.inVisibleStyles,
            hideFixedValue: property.hideFixedValue
          };
          return result;
        }
      }
    }
  };

  renderComponentList = (): JSX.Element => {
    const sd: IScreenDesign = this.props.sd.getScreenDesign();
    let allDi: IDisplayItem[] = [];
    let allMasterDi: IDisplayItem[] = [];

    this.fillAllDisplayItemsRecursive(sd, allDi);
    // if (this.props.sd.masterSd) {
    //   this.fillAllDisplayItemsRecursive(this.props.sd.masterSd, allMasterDi);
    // }

    const specialDIIds = [
      SpecialDIIds.layoutLeftDI,
      SpecialDIIds.layoutHeaderDI,
      SpecialDIIds.layoutFooterDI,
      SpecialDIIds.layoutRightDI
    ];

    // specialDIIds.forEach((specialDIId) => {
    //   const index = allMasterDi.findIndex((di) => di.id.toString() === specialDIId.toString());
    //   if (index !== -1) {
    //     allMasterDi.splice(index, 1);
    //   }
    // });

    const rootDI = allDi.find((di) => di.id.toString() === SpecialDIIds.rootDI.toString() && di.children.length > 0);
    if (rootDI) {
      rootDI.friendlyName = "Screen";
    }
    // const masterRootDI = allMasterDi.find(
    //   (di) => di.id.toString() === SpecialDIIds.rootDI.toString() && di.children.length === 0
    // );
    // if (masterRootDI) {
    //   masterRootDI.friendlyName = "Master Screen";
    // }

    allDi.sort((a, b) => CommonHelperFunctions.compareObjectWithField(a, b, "friendlyName"));
    // allMasterDi.sort((a, b) => CommonHelperFunctions.compareObjectWithField(a, b, "friendlyName"));
    allDi = allDi.filter((a) => a.id > 0);
    // allMasterDi = allMasterDi.filter((a) => a.id > 0);

    // A component is picked by its place in this sorted list rather than by its id, and
    // handleComponentSelect reads the picked index back out of the same list.
    const componentGroups: KuikaSelectboxOptionGroup[] =
      allDi.length > 0
        ? [
            {
              label: "Screen",
              options: allDi.map((di: IDisplayItem, index: number): KuikaSelectboxOption => ({
                key: di.id.toString(),
                value: index,
                label: di.friendlyName
              }))
            }
          ]
        : [];
    // if (allMasterDi && allMasterDi.length > 0) {
    //   options.push({
    //     label: "Master Screen",
    //     options: allMasterDi.map((di, i) => ({
    //       label: di.friendlyName,
    //       value: `${i}_master`
    //     }))
    //   });
    // }

    return (
      <>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          Select Component
        </div>
        <div className="kuika_property-grid-column">
          <KuikaSelectbox
            searchable
            size="sm"
            style={{ width: "100%" }}
            value={this.getSelectValue(allDi, allMasterDi) ?? null}
            onChange={(val: number): void => {
              this.handleComponentSelect(val, allDi, allMasterDi);
            }}
            className="kuika_add_actions_inputs_size"
            groups={componentGroups}
          />
        </div>
      </>
    );
  };

  getAllDisplayItemsOfDi = (di: IDisplayItem, result: IDisplayItem[]) => {
    if (di.children)
      for (let i = 0; i < di.children.length; i++) {
        if (!di.children[i].friendlyName) {
          di.children[i].friendlyName = di.children[i].id.toString();
        }
        result.push(di.children[i]);
        this.getAllDisplayItemsOfDi(di.children[i], result);
      }
  };

  fillAllDisplayItemsRecursive = (sd: IDesign, result: IDisplayItem[]) => {
    if (sd.displayItems)
      for (let i = 0; i < sd.displayItems.length; i++) {
        if (!sd.displayItems[i].friendlyName) {
          sd.displayItems[i].friendlyName = sd.displayItems[i].id.toString();
        }
        result.push(sd.displayItems[i]);
        this.getAllDisplayItemsOfDi(sd.displayItems[i], result);
      }
  };

  render() {
    return <div style={{ width: "100%" }}>{this.renderComponentList()}</div>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const selectElementIdSymbolGroup = withContext<ISelectElementIdSymbolGroupProps>(
  withSD<ISelectElementIdSymbolGroupProps>(SelectElementIdSymbolGroup)
);
export { selectElementIdSymbolGroup as SelectElementIdSymbolGroup };
